import React from 'react';

import { Card, CardContent, CardHeader, CardTitle } from 'shadcn/components/ui/Card';

/**
 * Box type configuration with icons and labels.
 * Hoisted to module scope to avoid re-creation on each render.
 */
const BOX_TYPE_CONFIG = {
    regular: { icon: '\uD83E\uDD55', label: 'Regular' },
    frozen: { icon: '\u2744\uFE0F', label: 'Frozen' },
    oob: { icon: '\uD83D\uDCE6', label: 'OOB' },
};

/**
 * PalletCard
 *
 * Displays a single pallet's information including box type icon,
 * pallet ID, box count, and door assignment.
 *
 * @param {Object} props
 * @param {Object} props.pallet - Pallet data object
 * @param {string} props.pallet.palletId - Unique pallet identifier
 * @param {number} props.pallet.boxCount - Number of boxes on the pallet
 * @param {string|null} props.pallet.door - Door assignment, or null if unassigned
 * @param {string} props.pallet.boxType - Box type: 'regular' | 'frozen' | 'oob'
 */
function PalletCard({ pallet }) {
    const config = BOX_TYPE_CONFIG[pallet.boxType] || BOX_TYPE_CONFIG.regular;

    return (
        <Card data-testid={`pallet-card-${pallet.palletId}`}>
            <CardHeader className="pb-0">
                <CardTitle className="text-base flex items-center gap-2">
                    <span role="img" aria-label={config.label}>
                        {config.icon}
                    </span>
                    <span>{pallet.palletId}</span>
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-1 text-sm">
                <div className="flex justify-between">
                    <span className="text-muted-foreground">Boxes</span>
                    <span className="font-medium">{pallet.boxCount}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-muted-foreground">Door</span>
                    <span className="font-medium">{pallet.door ?? 'Unassigned'}</span>
                </div>
            </CardContent>
        </Card>
    );
}

export default PalletCard;
